import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { select, Store } from "@ngrx/store";
import { CommonState, LoginLimitProgressState, LoginLimitSelector } from "@obg/ngx.common";
import { ignoreNil } from "@obg/rxjs";
import { merge, Subscription } from "rxjs";
import { tap } from "rxjs/operators";

import { LoginLimitReminderData } from "./login-limit-reminder.model";

@Component({
	selector: "obg-login-limit-reminder-container",
	templateUrl: "./login-limit-reminder.container.html",
	styleUrls: ["./login-limit-reminder.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LoginLimitReminderContainer implements OnInit, OnDestroy {
	loginsLeft: number | undefined;
	loginLimitData: LoginLimitReminderData | undefined;

	private data$$: Subscription | undefined;

	constructor(
		private store: Store<CommonState>,
		private loginLimitSelector: LoginLimitSelector,
		private changeDetectorRef: ChangeDetectorRef,
		private dialog: MatDialogRef<any>
	) {}

	ngOnInit() {
		const loginLimitProgress$ = this.store.pipe(
			select(this.loginLimitSelector.getLoginLimitProgress()),
			ignoreNil(),
			tap((loginLimitProgress: LoginLimitProgressState) => {
				this.loginsLeft = loginLimitProgress?.currentProgress?.loginCountLimitStatuses[0].remainingLogins;
			})
		);

		this.data$$ = merge(loginLimitProgress$).subscribe(() => this.changeDetectorRef.markForCheck());
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	closeModal() {
		this.dialog.close();
	}
}
